/**
 * @file dependency injection symbols for this application.
 * @description clean up => should make Symbols for every inject (dependency injection)
 */

export const ALL_DATA_SERVICE = Symbol('allDataService');
export const WORKER_CLIENT = Symbol('workerClient');




